import {Component} from "react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import Card from "../screens/Card";
import {getEmployee} from "../../reducers/lamp-selector";
import store from "../../localStorage";

class CardContainer extends Component {
    constructor(props) {
        super(props);
        let id = props.match.params.id;
        let employee = getEmployee(store.getState(), id);
        this.state = {
            employee: employee,
        }
        document.title = props.app.document_title || props.t('Display settings');
    }

    render() {
        return <Card {...this.state} {...this.props}/>
    }
}

const mapStateToProps = (store) => {
    return {
        lamp: store.lampState,
        app: store.appState,
    };
};

export default connect(mapStateToProps)(withTranslation()(CardContainer));